import {Box} from '@mantine/core';
import type {FC} from 'react';
import {HOWTV_COMPANY_ADDRESS} from '../../../core/entities/shared/howtvInfo';
import {SectionTitle} from '../../../shared/components/SectionTitle';

const TEXT_CLASSNAME = 'leading-normal text-black text-base';

export const PmarkTextComponent: FC = () => {
  return (
    <>
      <div className="section-box">
        <SectionTitle order={2} title="個人情報の取扱い" />
      </div>
      <Box className="mb-16 bg-white px-8 py-32 pc:px-32">
        <div className="mb-16">
          <p className="mb-12 text-center px-8 py-4 text-md font-bold leading-normal text-black">
            個人情報取得時の通知事項
            <br />
            お問い合わせフォームにおける個人情報の取扱いについて
          </p>
        </div>
        <div className="mb-16">
          <p className="font-bold mb-12 mt-16 bg-background-1 px-8 py-4 text-md leading-normal text-black">
            1. 事業者の名称
          </p>
          <p className={TEXT_CLASSNAME}>株式会社ハウテレビジョン</p>
          <p className="font-bold mb-12 mt-16 bg-background-1 px-8 py-4 text-md leading-normal text-black">
            2. 個人情報の利用目的
          </p>
          <p className={TEXT_CLASSNAME}>
            弊社は、次の者を個人情報の保護管理者として任命し、
            お客様の個人情報を適切かつ安全に管理し、個人情報の漏えい、滅失又はき損を防止する保護策を講じています。
            <br />
            <br />
          </p>
          <p className={TEXT_CLASSNAME}>
            株式会社ハウテレビジョン 個人情報保護管理責任者 清水 伸太郎
            <br />
            {HOWTV_COMPANY_ADDRESS}
            <br />
            TEL：03-6427-2862
          </p>
          <p className="font-bold mb-12 mt-16 bg-background-1 px-8 py-4 text-md leading-normal text-black">
            3. 個人情報の利用目的
          </p>
          <p className={TEXT_CLASSNAME}>
            『外資就活
            お問い合わせ』フォームにご入力いただいたお客様の個人情報は、外資就活ドットコムに関するお問い合わせ対応（本人への連絡を含む）のため、また、『就活情報のタレコミ』フォームにご入力いただいたお客様の個人情報は、いただいた『就活情報のタレコミ』
            に関する対応（本人への連絡を含む）のため、弊社において正当な事業遂行の範囲内で利用いたします。
          </p>
          <p className="font-bold mb-12 mt-16 bg-background-1 px-8 py-4 text-md leading-normal text-black">
            4. 個人情報の第三者への提供
          </p>
          <p className={TEXT_CLASSNAME}>
            お客様の個人情報は、以下掲げる場合以外に、事前にご本人の同意無く第三者に提供することはありません。
          </p>
          <p className={TEXT_CLASSNAME}>(1)法令に基づく場合</p>
          <p className={TEXT_CLASSNAME}>
            (2)人の生命、身体又は財産の保護にために必要がある場合であって、本人の同意を得る事が困難であるとき
          </p>
          <p className={TEXT_CLASSNAME}>
            (3)公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得る事が困難であるとき
          </p>
          <p className={TEXT_CLASSNAME}>
            (4)国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、
            本人の同意を得ることによって当該事務の遂行に支障を及ぼすおそれがあるとき
          </p>
          <p className="font-bold mb-12 mt-16 bg-background-1 px-8 py-4 text-md leading-normal text-black">
            5. 個人情報の取扱業務の委託
          </p>
          <p className={TEXT_CLASSNAME}>
            前項にかかわらず、弊社は事業運営上、第３項に定める利用目的の範囲に限って個人情報の取扱業務を外部に委託することがあります。
            この場合、弊社は、個人情報の適切な管理・保護体制を敷いて実施している委託先を選定し、個人情報の適正管理・機密保持について
            の契約を交わし、厳密に管理を実施させます。
          </p>
          <p className="font-bold mb-12 mt-16 bg-background-1 px-8 py-4 text-md leading-normal text-black">
            6. お客様からの使用停止、削除等の申込みへの応諾
          </p>
          <p className={TEXT_CLASSNAME}>
            お客様は、弊社に対してご自身の個人情報の開示等
            （利用目的の通知、開示、内容の訂正・追加・削除、利用の停止または消去、第三者への提供の停止）に関して、当社問い合わせ窓口に
            申し出ることができます。
          </p>
          <p className={TEXT_CLASSNAME}>
            その際、弊社はお客様ご本人を確認させていただいたうえで、合理的な期間内に対応いたします。
            なお、個人情報に関する弊社問い合わせ先は、次の通りです。
          </p>
        </div>
        <div>
          <p className="mb-12 mt-16 py-4 text-md font-bold leading-normal text-black">
            【お問合せ窓口】
          </p>
          <p className="mb-12 text-base leading-normal text-black">
            個人情報保護方針に関するお問合せにつきましては、下記窓口で受付けております。
          </p>
          <p className="text-sm leading-normal text-black pc:text-base">
            株式会社ハウテレビジョン&nbsp;&nbsp;個人情報問い合わせ窓口
          </p>
          <p className="text-sm leading-normal text-black pc:text-base">
            {HOWTV_COMPANY_ADDRESS}
          </p>
          <p className="text-sm leading-normal text-black pc:text-base">
            メールアドレス：soumu@howtelevision.jp
          </p>
          <p className="text-sm leading-normal text-black pc:text-base">
            TEL：03-6427-2862
          </p>
          <p className="text-sm leading-normal text-black pc:text-base">
            （受付時間&nbsp;10:00～19:00&nbsp;&nbsp;※土・日曜日、祝日、年末年始、ゴールデンウィークを除く）
          </p>
        </div>
        <div>
          <p className="mb-12 mt-16 bg-background-1 px-8 py-4 text-md font-bold leading-normal text-black">
            7. 個人情報を提供されることの任意性について
          </p>
          <p className={TEXT_CLASSNAME}>
            ご本人が当社に個人情報を提供されるかどうかは任意によるものです。
            ただし、必要な項目をいただけない場合、
            適切な対応ができない場合があります。
          </p>
        </div>
      </Box>
    </>
  );
};
